//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoSet } from 'pojo-sets';
import { createSelector } from 'reselect';

import { IGallery } from '@apis/galleries/galleriesApiModels';
import { ICuralateStore } from '@models/AppState';
import ReelId from '@models/ReelId';
import { crl8 } from 'app/curalate.globals';
import { getAllAlphabetizedGalleries } from '../getAllAlphabetizedGalleries';

export const getNumSelectedRightsManagedGalleriesImpl = (
  selectedReelIds: PojoSet<ReelId>,
  allGalleries: IGallery[],
  isBazaarvoiceSyndicationSelected: boolean = false,
  isRightsManagementEnabled: boolean = false,
): number => {
  const numSelectedRightsManagedGalleries = PojoSet.toArray(
    selectedReelIds,
  ).filter((reelId) => {
    const galleryOpt = allGalleries.find(
      (gallery) => gallery.reelId === reelId,
    );

    if (galleryOpt) {
      return galleryOpt.isRightsManaged;
    } else {
      crl8.logger.cloud.error(
        `ReelId: ${reelId} appeared in the bulk rights modal but isn't a fetched gallery!`,
      );
      return false;
    }
  }).length;

  const numSelectedRightsManagedDistributionGalleries =
    isBazaarvoiceSyndicationSelected && isRightsManagementEnabled ? 1 : 0;

  return (
    numSelectedRightsManagedGalleries +
    numSelectedRightsManagedDistributionGalleries
  );
};

export const getNumSelectedRightsManagedGalleries = createSelector(
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.gallerySelection,
  getAllAlphabetizedGalleries,
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.isBazaarvoiceSyndicationSelected,
  (state: ICuralateStore) => !!state.session.features.rights_management_page,
  getNumSelectedRightsManagedGalleriesImpl,
);
